import { abortableFetch, useEventCallback } from '@eas/common-web';
import { Draft } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useAddDraftDialog() {
  const callApi = useEventCallback((id: string, formData: Draft) => {
    return abortableFetch(`${EvidenceApiUrl.ES_FILES}/${id}/draft`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(formData),
    });
  });

  return {
    callApi,
  };
}
